import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export interface RowVisibilityRow {
  original: Record<string, any>;
}

export interface RowVisibilityContext {
  subdomain: string;
  hideEditButtonForRows?: boolean;
  hideDeleteButtonForRows?: boolean;
  disallowDelete?: boolean;
  disableDeleteButtonForRow?: (row: any) => boolean;
  entityAdapter?: EntityAdapter;
}

// entity rules shared by the edit and the delete action
const isRowActionAllowedForEntity = (
  row: RowVisibilityRow,
  ctx: Pick<RowVisibilityContext, "subdomain" | "entityAdapter">
): boolean => ctx.entityAdapter?.isRowActionAllowed?.(row.original, ctx) ?? true;

export const canShowRowEdit = (
  row: RowVisibilityRow,
  ctx: RowVisibilityContext
): boolean =>
  isRowActionAllowedForEntity(row, ctx) && !ctx.hideEditButtonForRows;

export const canShowRowDelete = (
  row: RowVisibilityRow,
  ctx: RowVisibilityContext
): boolean =>
  isRowActionAllowedForEntity(row, ctx) && !ctx.hideDeleteButtonForRows;

export const isRowDeleteDisabled = (
  row: RowVisibilityRow,
  ctx: RowVisibilityContext
): boolean =>
  Boolean(
    ctx.disallowDelete === true ||
      row.original.can_be_deleted === false ||
      ctx.disableDeleteButtonForRow?.(row)
  );

export const isBulkDeleteEnabled = (
  enableBulkDelete: boolean | ((selectedRows: any[]) => boolean) | undefined,
  selectedRows: any[]
): boolean => {
  if (!enableBulkDelete) {
    return false;
  }
  if (typeof enableBulkDelete === "function") {
    return enableBulkDelete(selectedRows);
  }
  return enableBulkDelete;
};
